module.exports = "/_next/static/images/IEEE-screenshot-5e970e92ce53a093065e7a2a22fe5007.png";